import type { editor } from '@/store/editor/types';

export const editorStub: editor = {
  dataSettings: {},
  dataSnippets: {},
  animations: {
    actions: {},
    interactions: {},
  },
  showShortcutModal: false,
  beforeStylePreviewModeGlobalStyle: {},
  isLoadingDynamicData: false,
  isLoadingEditor: true,
  isBlankPage: false,
  loadFinishALLMER: false,
};
